const GainMPEvent = function( battleState, potency ) {
	this.eventHandle = 'gain_mp';
	this.potency = potency;	

	this.execute = ( victim ) => {
		this.victimId = victim.uid;

		victim.mp += this.potency;

		this.affectedPieces = [ victim ]; 
		battleState.onBattleEvent( this );	
	};
};
module.exports = GainMPEvent
